<template>
    <div class="chart_wrapper" id="ChartWrapper" data-chart="area">
        <div class="highcharts_container" :id="chartID" ></div>
    </div>
</template>

<script>
    import * as UTILS from '~/commons/utils/index.js'
    import { mapState, mapGetters, mapActions } from 'vuex'
    import axios from 'axios'
    import {_} from 'underscore'
    var numberFormat = require('underscore.string/numberFormat')

    export default {
        props: {
            chartID: {
                type: String,
                default: function () {
                    return 'BarChart'
                }
            },
            barChartData: {
                type: Array,
                default: function () {
                    return []
                }
            },
            barChartCategories: {
                type: Array,
                default: function () {
                    return []
                }
            },
            indicatorUnit: {
                type: String, 
                default: function (){
                    return ""
                }
            },
            indicatorLabel: {
                type: String, 
                default: function (){
                    return ""
                }
            }
        },
        data: function () {
            return {
                barChartHigcharts: '',
            }
        },
        
        mounted () {
            var self = this;
            this.renderBarChart();
        },
        methods: {

            renderBarChart: function () {
                var self = this;

                this.barChartHigcharts = new Highcharts.chart({
                    chart: {
                        type: 'bar',
                        renderTo: self.chartID,
                        backgroundColor: "transparent",
                    },
                    title: {
                        text: '',
                        align: 'left',
                        enabled: false
                    },
                    legend: {
                        align: "left",
                        verticalAlign: "top"
                    },
                    xAxis: {
                        categories: this.barChartCategories,
                        gridLineDashStyle: "solid",
                        gridLineColor: "#BAC6Df",
                        gridLineWidth: 0,
                        lineWidth: 1,
                        lineColor: "#29264C"
                    },
                    yAxis: {
                        gridLineDashStyle: "solid",
                        gridLineColor: "#BAC6Df",
                        gridLineWidth: 1,
                        lineWidth: 0,
                        title: {
                            enabled: false
                        }
                    },
                    tooltip:{
                        useHTML: true,
                        formatter: function (){
                            var formattedNumber = "";
                            if(this.y > 1) {
                                formattedNumber = this.y.toFixed(2);
                            } else {
                                formattedNumber = UTILS.formatNumber(this.y, 2, self.indicatorUnit);
                            }
                            var htmlTooltip = "<div class='tooltip_wrapper'>";
                            htmlTooltip += "<div class='tooltip_title'>"+this.x+"</div>";
                            htmlTooltip += "<div class='tooltip_value'><div class='value_label'>"+self.indicatorLabel+"</div><div class='value_figure'><div class='figure_bar' style='background-color:"+this.color+"'></div>" + formattedNumber + "" +self.indicatorUnit+"</div></div>";
                            htmlTooltip += "</div>";
                            return htmlTooltip;
                        }
                    },
                    legend:{
                        enabled: false
                    },
                    credits: {
                        enabled: false
                    },
                    plotOptions: {
                        series: {
                            borderWidth: 0,
                            pointWidth: 20,
                            groupPadding: 0.1
                        }
                    },
                    series: this.barChartData
                });
            },
        },
        watch: {
            barChartData: function () {
                if(this.barChartData[0] !== undefined) {
                    this.renderBarChart();
                }
            }
        }
    }
</script>

<style lang="scss">
    @import "~assets/scss/_variables.scss";
    @import "~assets/scss/_browsers.scss";

    .chart_wrapper{
        width: 100%;
        height: 100%;
        position: relative;
        text-align: center;

        .highcharts_container{
            width: 100% !important;
            height: 100% !important;
        }
    }
</style>



// WEBPACK FOOTER //
// components/highchartsBarChart.vue